import React from "react";
import PageContainer from "../layout/PageContainer";

const PrivacyPolicyPage = () => {
  return (
    <PageContainer>
      <div>PRIVACY POLICY</div>
    </PageContainer>
  );
};

export default PrivacyPolicyPage;
